import React, { useState, useEffect } from 'react';
import './style.css';

const ActionData = () => {
  // State for countdown values
  const [countdown, setCountdown] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
    isChristmas: false,
  });

  useEffect(() => {
    const christmasCountDown = () => {
      const now = new Date();
      const currentMonth = now.getMonth() + 1; // Month is zero-indexed, so add 1
      const currentDay = now.getDate();

      let nextChristmasYear = now.getFullYear();
      if (currentMonth === 12 && currentDay > 25) {
        nextChristmasYear += 1;
      }

      const nextChristmasDate = `Dec 25, ${nextChristmasYear} 00:00:00`;
      const christmasDay = new Date(nextChristmasDate);
      const timeLeft = christmasDay - now;

      let days = 0,
          hours = 0,
          minutes = 0,
          seconds = 0,
          isChristmas = false;

      // Only calculate time left if it's not Christmas Day
      if (currentMonth !== 12 || (currentMonth === 12 && currentDay !== 25)) {
        days = Math.floor(timeLeft / 1000 / 60 / 60 / 24);
        hours = Math.floor(timeLeft / 1000 / 60 / 60) % 24;
        minutes = Math.floor(timeLeft / 1000 / 60) % 60;
        seconds = Math.floor(timeLeft / 1000) % 60;
      } else {
        isChristmas = true;
      }

      setCountdown({
        days: days < 10 ? `0${days}` : days,
        hours: hours < 10 ? `0${hours}` : hours,
        minutes: minutes < 10 ? `0${minutes}` : minutes,
        seconds: seconds < 10 ? `0${seconds}` : seconds,
        isChristmas,
      });
    };

    // Update every second
    const interval = setInterval(christmasCountDown, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {countdown.isChristmas ? (
        <div className="action__title" id="msg-christmas">
          Today is Dec 25, Merry Christmas!
        </div>
      ) : (
        <div className="action__title" id="title-data">
          Last
          <div className="action__number" id="number-data">
            {countdown.days}
          </div>
          <div className="action__text" id="text-data">Days</div>
          To Receive<span className='accent'> Christmas</span>
          <div className="action__number" id="number-data">
            {countdown.hours}
          </div>
          <div className="action__text" id="text-data">Hours</div>
          <div className="action__number" id="number-data">
            {countdown.minutes}
          </div>
          <div className="action__text" id="text-data">Minutes</div>
          <div className="action__number" id="number-data">
            {countdown.seconds}
          </div>
          <div className="action__text" id="text-data">Seconds</div>
        </div>
      )}
    </>
  );
};

export default ActionData;
